import _ from 'lodash'
import { Vue } from 'vue-property-decorator'
import { MutationTree } from 'vuex'
import { mutationType } from './mutation-types'
import FormComponentState from './states'

const mutations: MutationTree<FormComponentState> = {
  [mutationType.UPDATE_VALUE](
    state: FormComponentState,
    data: { [key: string]: any },
  ): void {
    if (data.attrName) {
      const initData = state.data[data.formName] ? _.clone(state.data[data.formName]) : {}
      Vue.set(
        state.data,
        data.formName,
        _.set(initData, data.attrName, data.value),
      )
    }
  },
  [mutationType.INIT_FORM](
    state: FormComponentState,
    { formName, value }: { [key: string]: any },
  ): void {
    Vue.set(state.data, formName, value)
  },
  [mutationType.REMOVE_FORM](
    state: FormComponentState,
    formName: string,
  ): void {
    Vue.delete(state.data, formName)
  },
}

export default mutations
